<!-- 
  由于部分手机存在无法刷新本页面的情况，其它页面需要刷新的时候，先跳转到此页面，然后此页面会立刻返回，
  达到刷新的效果
-->

<template>
  <div class="null-page"></div>
</template>

<script>
export default {
  name: "null",
  data() {
    this.$router.go(-1);
    return {};
  }
};
</script>

<style scoped lang="scss">
.null-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #eee;
}
</style>
